module.exports = __webpack_public_path__ + "media/images/emblems/Wildberg-blazon-01ab6d2b12e2270fd263b45b645950d3.svg";